<template>
  <div class="sf-house-container">
    <!-- ====== 顶部：筛选区域 ====== -->
    <div class="filter-section">
      <el-form :inline="true" size="small" class="filter-form" :model="filterForm">
        <el-form-item label="行政区">
          <el-select 
            v-model="filterForm.行政区" 
            placeholder="请选择行政区" 
            clearable 
            style="width:150px"
            @change="handleSearch"
          >
            <el-option label="青秀区" value="青秀区" />
            <el-option label="兴宁区" value="兴宁区" />
            <el-option label="江南区" value="江南区" />
            <el-option label="良庆区" value="良庆区" />
            <el-option label="邕宁区" value="邕宁区" />
            <el-option label="西乡塘区" value="西乡塘区" />
            <el-option label="武鸣区" value="武鸣区" />
            <el-option label="横州市" value="横州市" />
            <el-option label="宾阳县" value="宾阳县" />
            <el-option label="上林县" value="上林县" />
            <el-option label="马山县" value="马山县" />
            <el-option label="隆安县" value="隆安县" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="房屋地址">
          <el-input 
            v-model="filterForm.房屋地址" 
            placeholder="请输入房屋地址" 
            clearable 
            style="width:200px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="收房门店">
          <el-input 
            v-model="filterForm.收房门店" 
            placeholder="请输入收房门店" 
            clearable 
            style="width:150px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="业务状态">
          <el-select 
            v-model="filterForm.业务状态" 
            placeholder="请选择状态" 
            clearable 
            style="width:130px"
            @change="handleSearch"
          >
            <el-option label="待出租" value="待出租" />
            <el-option label="已出租" value="已出租" />
            <el-option label="已到期" value="已到期" />
            <el-option label="已中止" value="已中止" />
            <el-option label="装修中" value="装修中" />
            <el-option label="自用房" value="自用房" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="合同起始日">
          <el-date-picker
            v-model="filterForm.合同起始日范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="合同到期日">
          <el-date-picker
            v-model="filterForm.合同到期日范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>
        
        <el-form-item label="收房人">
          <el-input 
            v-model="filterForm.收房人" 
            placeholder="请输入收房人" 
            clearable 
            style="width:120px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ====== 中间：按钮区域 ====== -->
    <div class="button-section">
      <el-button type="primary" size="medium" icon="el-icon-plus" @click="handleAdd">
        新建房源信息
      </el-button>
      <el-button 
        type="info" 
        size="medium" 
        icon="el-icon-view"
        :disabled="!canOperate"
        @click="handleDetail"
      >
        详情
      </el-button>
      <el-button 
        type="warning" 
        size="medium" 
        icon="el-icon-edit"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleEdit"
      >
        修改
      </el-button>
     <el-button 
      type="danger" 
      size="medium" 
      icon="el-icon-delete"
      :disabled="!canOperate || selectedRows.length !== 1"
      @click="handleDelete"
      :loading="selectedRows.length === 1 && deletingIds.includes(selectedRows[0].id)"
    >
      删除
    </el-button>
      <el-button 
        type="info" 
        size="medium" 
        icon="el-icon-document"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleContractTerminate"
      >
        合同终止
      </el-button>
      <el-button 
        type="primary" 
        size="medium" 
        icon="el-icon-paperclip"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="openAttachmentManager"
      >
        修改附件
      </el-button>
      <el-button 
        type="success" 
        size="medium" 
        icon="el-icon-house"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="handleChangeToRent"
      >
        更改为待出租
      </el-button>
      <el-button
        type="success"
        size="medium"
        icon="el-icon-date"
        :disabled="!canOperate || selectedRows.length !== 1"
        @click="openPlanDialog"
      >
        生成付款计划
      </el-button>
    </div>

    <!-- ====== 下方：表格区域 ====== -->
    <div class="table-section">
     <el-table
      ref="tableRef"
      :data="tableData"
      border
      stripe
      highlight-current-row
      v-loading="loading"
      @selection-change="handleSelectionChange"
      @row-click="handleRowClick"
      @row-dblclick="handleRowDblclick"     
      style="width: 100%"
      max-height="600"
    >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        
        <el-table-column prop="行政区" label="行政区" width="120" show-overflow-tooltip />
        
        <el-table-column prop="房屋地址" label="房屋地址" min-width="200" show-overflow-tooltip />
          <el-table-column prop="业务状态" label="业务状态" width="120" show-overflow-tooltip align="center" />
        <el-table-column prop="面积（平米）" label="面积" width="100" align="center">
          <template slot-scope="{ row }">
            {{ row['面积（平米）'] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="室" label="室" width="60" align="center" />
        <el-table-column prop="厅" label="厅" width="60" align="center" />
        <el-table-column prop="卫" label="卫" width="60" align="center" />
        <el-table-column prop="收房费用" label="收房费用" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.收房费用 ? `¥${row.收房费用}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="收房指导价" label="收房指导价" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.收房指导价 ? `¥${row.收房指导价}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="收房渠道" label="收房渠道" width="120" show-overflow-tooltip align="center" />
        <el-table-column prop="合同起始日" label="合同起始日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同起始日) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同到期日" label="合同到期日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同到期日) }}
          </template>
        </el-table-column>
        <el-table-column prop="收房人" label="收房人" width="100" />
        <el-table-column prop="合同编号" label="合同编号" width="150" show-overflow-tooltip />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          background
        />
      </div>
    </div>
 
   <!-- ====== 详情弹窗 ====== -->
<el-dialog
  title="房源详情"
  :visible.sync="detailDialog.visible"
  width="1000px"
  :close-on-click-modal="false"
  class="detail-dialog"
>
  <el-tabs v-model="detailActiveTab" type="border-card">
    <!-- 1. 基础信息 -->
    <el-tab-pane label="基础信息" name="base">
      <el-descriptions :column="2" border size="medium">
        <el-descriptions-item label="产权证地址" :span="2">
          {{ detailData.产权证地址 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="不动产权号">
          {{ detailData.不动产权号 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="丘权号">
          {{ detailData.丘权号 || '-' }}
        </el-descriptions-item>
        
       <!-- 行政区 + 业务状态 -->
      <el-descriptions-item label="行政区" :span="1">
        {{ detailData.行政区 || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="业务状态" :span="1">
        <el-tag :type="getBusinessStatusType(detailData.业务状态)" size="small">
          {{ detailData.业务状态 || '-' }}
        </el-tag>
      </el-descriptions-item>
        
        <el-descriptions-item label="出房指导价">
          {{ detailData.出房指导价 ? `¥${detailData.出房指导价}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="收房指导价">
          {{ detailData.收房指导价 ? `¥${detailData.收房指导价}` : '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="收房人">
          {{ detailData.收房人 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="收房门店">
          {{ detailData.收房门店 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="室">
          {{ detailData.室 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="厅">
          {{ detailData.厅 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="卫">
          {{ detailData.卫 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="面积（平米）">
          {{ detailData['面积（平米）'] || '-' }}
        </el-descriptions-item>
        
        <!-- 楼层信息 -->
        <el-descriptions-item label="楼层信息" :span="2">
        <div style="display: flex; gap: 30px;">
          <span>第{{ detailData['楼层信息（第X层）'] || '-' }}层</span>
          <span>共{{ detailData['楼层信息（共X层）'] || '-' }}层</span>
        </div>
      </el-descriptions-item>
        
        <el-descriptions-item label="用途" :span="2">
          {{ detailData.用途 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="朝向" :span="2">
          {{ detailData.朝向 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="水卡">
          {{ detailData.水卡 || '-' }}
        </el-descriptions-item>
        <!-- 修改2：电卡用户名 和 气卡 互换位置 -->
        <el-descriptions-item label="气卡">
          {{ detailData.气卡 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="电卡">
          {{ detailData.电卡 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="电卡用户名">
          {{ detailData.电卡用户名 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="其他卡" :span="2">
          {{ detailData.其他卡 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="钥匙/密码" :span="2">
          {{ detailData['钥匙/密码'] || '-' }}
        </el-descriptions-item>
        <!-- 修改3：新增备注行 -->
        <el-descriptions-item label="备注" :span="2">
          {{ detailData.备注 || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-tab-pane>
<!-- 2. 附件信息 -->
<el-tab-pane label="附件信息" name="attachment">
  <div class="attachment-section">
    <!-- ====== 产证信息 ====== -->
    <div class="file-group">
      <div class="file-group-title">产证信息</div>
      <el-table :data="attachmentData['产证信息']" border stripe size="small" v-loading="attachmentLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              <el-image
                :src="row.show_path_full || row.show_path"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                :preview-src-list="[row.show_path_full || row.show_path]"
              />
            </div>
            <span v-else class="preview-placeholder">仅支持图片预览</span>
          </template>
        </el-table-column>
        <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!attachmentData['产证信息'] || attachmentData['产证信息'].length === 0" class="empty-tip">
        暂无产证信息文件
      </div>
    </div>

    <!-- ====== 身份证信息 ====== -->
    <div class="file-group">
      <div class="file-group-title">身份证信息</div>
      <el-table :data="attachmentData['身份证信息']" border stripe size="small" v-loading="attachmentLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              <el-image
                :src="row.show_path_full || row.show_path"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                :preview-src-list="[row.show_path_full || row.show_path]"
              />
            </div>
            <span v-else class="preview-placeholder">仅支持图片预览</span>
          </template>
        </el-table-column>
        <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!attachmentData['身份证信息'] || attachmentData['身份证信息'].length === 0" class="empty-tip">
        暂无身份证信息文件
      </div>
    </div>

    <!-- ====== 房屋原貌 ====== -->
    <div class="file-group">
      <div class="file-group-title">房屋原貌</div>
      <el-table :data="attachmentData['房屋原貌']" border stripe size="small" v-loading="attachmentLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
        <el-table-column prop="type_2" label="分类" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small">{{ row.type_2 || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              <el-image
                :src="row.show_path_full || row.show_path"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                :preview-src-list="[row.show_path_full || row.show_path]"
              />
            </div>
            <span v-else class="preview-placeholder">仅支持图片预览</span>
          </template>
        </el-table-column>
        <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!attachmentData['房屋原貌'] || attachmentData['房屋原貌'].length === 0" class="empty-tip">
        暂无房屋原貌文件
      </div>
    </div>

    <!-- ====== 房屋托管合同信息 ====== -->
    <div class="file-group">
      <div class="file-group-title">房屋托管合同信息</div>
      <el-table :data="attachmentData['房屋托管合同信息']" border stripe size="small" v-loading="attachmentLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              <el-image
                :src="row.show_path_full || row.show_path"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                :preview-src-list="[row.show_path_full || row.show_path]"
              />
            </div>
            <span v-else class="preview-placeholder">仅支持图片预览</span>
          </template>
        </el-table-column>
        <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!attachmentData['房屋托管合同信息'] || attachmentData['房屋托管合同信息'].length === 0" class="empty-tip">
        暂无房屋托管合同信息文件
      </div>
    </div>

    <!-- ====== 委托授权书 ====== -->
    <div class="file-group">
      <div class="file-group-title">委托授权书</div>
      <el-table :data="attachmentData['委托授权书']" border stripe size="small" v-loading="attachmentLoading">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
        <el-table-column label="预览" width="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="isImage(row.suffix)" class="preview-thumbnail">
              <el-image
                :src="row.show_path_full || row.show_path"
                fit="cover"
                style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                :preview-src-list="[row.show_path_full || row.show_path]"
              />
            </div>
            <span v-else class="preview-placeholder">仅支持图片预览</span>
          </template>
        </el-table-column>
        <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="handleFileView(row)">查看</el-button>
            <el-button type="text" size="mini" @click="handleFileDownload(row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!attachmentData['委托授权书'] || attachmentData['委托授权书'].length === 0" class="empty-tip">
        暂无委托授权书文件
      </div>
    </div>
  </div>
</el-tab-pane>

    <!-- 3. 收房详情 -->
    <el-tab-pane label="收房详情" name="receive">
      <el-descriptions :column="2" border size="medium">
        <el-descriptions-item label="产权人" :span="2">
          {{ detailData.房东姓名 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="产权人电话">
          {{ detailData.房东电话 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="产权人身份证号">
          {{ detailData.产权人身份证号 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="受托代理人姓名">
          {{ detailData.受托代理人姓名 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="委托人电话">
          {{ detailData.委托人电话 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="送达地址" :span="1">
          {{ detailData.送达地址 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="合同编号" :span="1">
          {{ detailData.合同编号 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="收房渠道">
          {{ detailData.收房渠道 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="收房费用">
          {{ detailData.收房费用 ? `¥${detailData.收房费用}` : '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="合同起始日">
          {{ formatTimestamp(detailData.合同起始日) }}
        </el-descriptions-item>
        <el-descriptions-item label="合同到期日">
          {{ formatTimestamp(detailData.合同到期日) }}
        </el-descriptions-item>
        
        <el-descriptions-item label="第一年免租期（天）">
          {{ detailData['第一年免租期（天）'] || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="第二年免租期（天）">
          {{ detailData['第二年免租期（天）'] || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="第三年免租期（天）">
          {{ detailData['第三年免租期（天）'] || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="免租期备注">
          {{ detailData.免租期备注 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="押金">
          {{ detailData.押金 ? `¥${detailData.押金}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="收房租金（元/月）">
          {{ detailData['收房租金（元/月）'] ? `¥${detailData['收房租金（元/月）']}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="支付周期" :span="2">
          {{ detailData.支付周期 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="特别约定" :span="2">
          {{ detailData.特别约定 || '-' }}
        </el-descriptions-item>
        
        <el-descriptions-item label="支付户名">
          {{ detailData.支付户名 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="银行卡号">
          {{ detailData.银行卡号 || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="开户行" :span="2">
          {{ detailData.开户行 || '-' }}
        </el-descriptions-item>
         <!-- ====== 新增：交房信息 ====== -->
        <el-descriptions-item label="交房日期" :span="2">
          {{ formatTimestamp(detailData.交房日期) }}
        </el-descriptions-item>
        <el-descriptions-item label="是否开通燃气" :span="2">
          {{ detailData.是否开通燃气 || '-' }}
        </el-descriptions-item>
      </el-descriptions>
    </el-tab-pane>

    <!-- ====== 修改4：新增 "付款要素和计划" Tab ====== -->
<!-- ====== 付款要素和计划 Tab ====== -->
<el-tab-pane label="付款要素和计划" name="payment">
  <div class="payment-section">
    <el-table :data="paymentList" border stripe style="width: 100%" v-loading="paymentLoading">
      <el-table-column prop="payment_date" label="付款日期" width="180" align="center">
        <template slot-scope="{ row }">
          {{ row.payment_date || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="payment_amount" label="付款金额" width="150" align="center">
        <template slot-scope="{ row }">
          ¥{{ (row.payment_amount || 0).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag 
            :type="getPaymentStatusType(row.status)" 
            size="medium"
            class="status-tag"
          >
            {{ getPaymentStatusLabel(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip />
    </el-table>
    
    <!-- 如果没有数据，显示空状态 -->
    <div v-if="paymentList.length === 0 && !paymentLoading" class="empty-payment">
      <i class="el-icon-document" />
      <span>暂无付款计划数据</span>
    </div>
  </div>
</el-tab-pane>
  </el-tabs>
  
  <span slot="footer">
    <el-button @click="detailDialog.visible = false">关闭</el-button>
    <el-button type="primary" @click="handleEditFromDetail" v-if="detailData.id">
      编辑
    </el-button>
  </span>
</el-dialog>

 <!-- 新增弹窗 -->
    <add-sf-house
      :visible.sync="addDialogVisible"
      @refresh="refresh"
    />
    <!-- 修改弹窗 -->
<update-sf-house
  :visible.sync="updateDialogVisible"
  :row-data="selectedRows[0]"
  @refresh="refresh"
/>
 <!-- 附件管理弹窗 -->
 <AttachmentManager
     :visible.sync="fileDialogVisible"
  :father-id="fileFatherId"
  @refresh="refresh"
  />
  <!-- 收房付款计划弹窗 -->
<sf-plan
  :visible.sync="planDialogVisible"
  :row-data="selectedRows[0]"
  @refresh="refresh"
/>

  
  </div>
  
</template>

<script>
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'
import UpdateSfHouse from './updateSfHouse.vue'
import AddSfHouse from './addSfHouse.vue'
import AttachmentManager from './AttachmentManager.vue'
import sfPlan from './sfPlan.vue'
import { fileMethod } from '@/api/files/fileMethod'
import { sfPlanApi } from '@/api/付款/sfPlanApi'
export default {
  name: 'SfHouse',
  components: {
    AddSfHouse,UpdateSfHouse,AttachmentManager,sfPlan
  },
  computed: {
  // 是否可以操作（单选时启用）
  canOperate() {
    return this.selectedRows.length === 1
  }
},
  data() {
    return {
      // ====== 筛选表单 ======
      filterForm: {
        行政区: '',
        房屋地址: '',
        收房门店: '',
        业务状态: '',
        合同起始日范围: [],
        合同到期日范围: [],
        收房人: ''
      },
      
      // ====== 表格数据 ======
      tableData: [],
      loading: false,
      selectedRows: [],
      // canOperate: false,
      
      // ====== 分页 ======
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      
      // ====== 详情弹窗 ======
      detailDialog: {
        visible: false
      },
      detailData: {},
      detailActiveTab: 'base',
       // ====== 付款要素和计划 ======
    paymentList: [],
    paymentLoading: false,
      
      // ====== 附件列表（预留） ======
      attachmentList: [
        { title: '产证信息', preview: '' },
        { title: '身份证信息', preview: '' },
        { title: '房屋托管合同信息', preview: '' },
        { title: '房屋原貌', preview: '' },
        { title: '授权委托书', preview: '' }
      ],
       paymentList: [
      {
        payment_date: '2026-08-15',
        payment_amount: 12000.00,
        status: 'pending',        // 待付
        remark: '8月租金'
      },
      {
        payment_date: '2026-09-15',
        payment_amount: 12000.00,
        status: 'paid',           // 已付
        remark: '9月租金'
      },
      {
        payment_date: '2026-10-15',
        payment_amount: 12000.00,
        status: 'partial',        // 部分付款
        remark: '10月租金（已付5000）'
      },
      {
        payment_date: '2026-11-15',
        payment_amount: 12000.00,
        status: 'terminated',     // 已中止
        remark: '合同已终止'
      },
      {
        payment_date: '2026-12-15',
        payment_amount: 12000.00,
        status: 'other',          // 其他
        remark: '待确认'
      },
      {
        payment_date: '2027-01-15',
        payment_amount: 13000.00,
        status: 'pending',        // 待付
        remark: '1月租金（续约）'
      }
    ],
     deletingIds: [],  // 确保是数组
    addDialogVisible: false,
     updateDialogVisible: false,
    //  附件控制
     fileFatherId: null,  // 新增：用于附件弹窗的 fatherId
    fileDialogVisible: false,
      currentRow: {},
       // ====== 附件数据 ======
    attachmentData: {
      '产证信息': [],
      '身份证信息': [],
      '房屋原貌': [],
      '房屋托管合同信息': [],
      '委托授权书': []
    },
    attachmentLoading: false,
       planDialogVisible: false
    }
  },
  
  mounted() {
    this.init()
  },
  
  methods: {
    // ====== 初始化加载数据 ======
    init() {
      this.loadData()
    },
    
    // ====== 后端字段 -> 前端字段映射 ======
// ====== 后端字段 -> 前端字段映射 ======
mapFields(data) {
  if (!data) return {}
  
  const fieldMap = {
    'id': 'id',
    '行政区': '行政区',
    '房屋地址': '房屋地址',
    '面积（平米）': '面积（平米）',
    '室': '室',
    '厅': '厅',
    '卫': '卫',
    '收房费用': '收房费用',
    '收房指导价': '收房指导价',
    '收房渠道': '收房渠道',
    '合同起始日': '合同起始日',
    '合同到期日': '合同到期日',
    '收房人': '收房人',
    '合同编号': '合同编号',
    '收房门店': '收房门店',
    '业务状态': '业务状态',
    '出房指导价': '出房指导价',
    '楼层信息': '楼层信息',
    '楼层信息（第X层）': '楼层信息（第X层）',
    '楼层信息（共X层）': '楼层信息（共X层）',
    '用途': '用途',
    '朝向': '朝向',
    '是否开通燃气': '是否开通燃气',
    '水卡': '水卡',
    '电卡用户名': '电卡用户名',
    '电卡': '电卡',
    '气卡': '气卡',
    '其他卡': '其他卡',
    '钥匙/密码': '钥匙/密码',
    '备注': '备注',
    '产权证地址': '产权证地址',
    '不动产权号': '不动产权号',
    '丘权号': '丘权号',
    '房东姓名': '房东姓名',
    '房东电话': '房东电话',
    '产权人身份证号': '产权人身份证号',
    '受托代理人姓名': '受托代理人姓名',
    '委托人电话': '委托人电话',
    '送达地址': '送达地址',
    '押金': '押金',
    '收房租金（元/月）': '收房租金（元/月）',
    '支付周期': '支付周期',
    '特别约定': '特别约定',
    '支付户名': '支付户名',
    '银行卡号': '银行卡号',
    '开户行': '开户行',
    '第一年免租期（天）': '第一年免租期（天）',
    '第二年免租期（天）': '第二年免租期（天）',
    '第三年免租期（天）': '第三年免租期（天）',
    '免租期备注': '免租期备注',
    '交房日期': '交房日期',
    'create_time': 'create_time',
    '小区名称': '小区名称',
    '房源类型': '房源类型',
    '房源标题': '房源标题',
    '装修标准': '装修标准',
    '房源简介': '房源简介'
  }
  
  const result = {}
  for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
    if (data.hasOwnProperty(backendKey)) {
      result[frontendKey] = data[backendKey]
    }
  }
  
  // ====== 时间戳字段统一转为毫秒级 ======
  const timestampFields = ['合同起始日', '合同到期日', '交房日期']
  timestampFields.forEach(field => {
    if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
      const str = String(result[field])
      // 如果是10位数（秒级），转为毫秒级
      if (str.length === 10) {
        result[field] = result[field] * 1000
      }
      // 如果是13位数（毫秒级），保持不变
    }
  })
  
  return result
},  
getBusinessStatusType(status) {
  const map = {
    '待出租': 'success',
    '已出租': 'warning',
    '已到期': 'info',
    '已中止': 'danger',
    '装修中': 'primary',
    '其他': 'info'
  }
  return map[status] || 'info'
},
    // ====== 加载数据 ======
    loadData() {
      this.loading = true
      
      const params = {
        tableName: '房源',
        conditions: [],
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize
      }
      
      // 添加筛选条件
      if (this.filterForm.行政区) {
        params.conditions.push({
          field: '行政区',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.行政区
        })
      }
      
      if (this.filterForm.房屋地址) {
        params.conditions.push({
          field: '房屋地址',
          type: 'STRING',
          operator: 'LIKE',
          value: `%${this.filterForm.房屋地址}%`
        })
      }
      
      if (this.filterForm.收房门店) {
        params.conditions.push({
          field: '收房门店',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.收房门店
        })
      }
      
      if (this.filterForm.业务状态) {
        params.conditions.push({
          field: '业务状态',
          type: 'STRING',
          operator: 'EQ',
          value: this.filterForm.业务状态
        })
      }
      
      // 合同起始日范围
      if (this.filterForm.合同起始日范围 && this.filterForm.合同起始日范围.length === 2) {
        const [start, end] = this.filterForm.合同起始日范围
        params.conditions.push({
          field: '合同起始日',
          type: 'TIMESTAMP',
          operator: 'GTE',
          value: Math.floor(start / 1000)
        })
        params.conditions.push({
          field: '合同起始日',
          type: 'TIMESTAMP',
          operator: 'LTE',
          value: Math.floor(end / 1000)
        })
      }
      
      // 合同到期日范围
      if (this.filterForm.合同到期日范围 && this.filterForm.合同到期日范围.length === 2) {
        const [start, end] = this.filterForm.合同到期日范围
        params.conditions.push({
          field: '合同到期日',
          type: 'TIMESTAMP',
          operator: 'GTE',
          value: Math.floor(start / 1000)
        })
        params.conditions.push({
          field: '合同到期日',
          type: 'TIMESTAMP',
          operator: 'LTE',
          value: Math.floor(end / 1000)
        })
      }
      
      if (this.filterForm.收房人) {
        params.conditions.push({
          field: '收房人',
          type: 'STRING',
          operator: 'LIKE',
          value: `%${this.filterForm.收房人}%`
        })
      }
      
      params.conditions.push({
        field: 'create_time',
        type: 'TIMESTAMP',
        operator: 'ORDER_BY_DESC'
      })
      
      console.log('请求参数===', params)
      
      sqlBaseApi.query(params).then((res) => {
        console.log('返回数据===', res)
        
        if (res.code === 200) {
          const rawList = res.data.list || []
          this.tableData = rawList.map(item => this.mapFields(item))
          this.pageInfo.total = res.data.total || 0
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        console.error('请求失败===', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    
    // ====== 搜索 ======
    handleSearch() {
      this.pageInfo.pageIndex = 1
      this.loadData()
    },
    
    // ====== 重置搜索 ======
    resetSearch() {
      this.filterForm = {
        行政区: '',
        房屋地址: '',
        收房门店: '',
        业务状态: '',
        合同起始日范围: [],
        合同到期日范围: [],
        收房人: ''
      }
      this.handleSearch()
    },
    
    // ====== 分页 ======
    handleSizeChange(size) {
      this.pageInfo.pageSize = size
      this.loadData()
    },
    
    handleCurrentChange(page) {
      this.pageInfo.pageIndex = page
      this.loadData()
    },
    
    // ====== 表格选择变化 ====== 
    handleSelectionChange(selection) {
      console.log('=== 表格选择变化 ===')
      console.log('选中的行数:', selection.length)
      console.log('选中数据:', selection)
      
      // 如果有选中的数据，打印每条数据的 id
      if (selection.length > 0) {
        selection.forEach((row, index) => {
          console.log(`选中第 ${index + 1} 条:`, {
            id: row.id,
            房屋地址: row.房屋地址,
            行政区: row.行政区
          })
        })
      } else {
        console.log('未选中任何行')
      }
      
      this.selectedRows = selection
    },
    
    // ====== 行点击 ======
    // ====== 行点击 ======
handleRowClick(row) {
  console.log('=== 行点击 ===')
  console.log('点击的行数据:', {
    id: row.id,
    房屋地址: row.房屋地址,
    行政区: row.行政区
  })
  
  // 切换选中状态
  this.$refs.tableRef.toggleRowSelection(row)
  
  // 获取当前选中的行
  const selection = this.$refs.tableRef.selection || []
  console.log('点击后当前选中的行数:', selection.length)
},
    
    // ====== 新建房源信息 ======
    handleAdd() {
      this.addDialogVisible = true
    },
    
    // ====== 详情 ======
    handleDetail() {
      if (this.selectedRows.length === 0) return
      this.detailData = { ...this.selectedRows[0] }
      this.detailActiveTab = 'base'
      this.detailDialog.visible = true
       // 加载附件数据
      if (this.selectedRows[0].id) {
        this.loadAttachmentData(this.selectedRows[0].id)
        // 加载付款计划数据
        this.loadPaymentData(this.selectedRows[0].id)
      }
    },
    
    // ====== 从详情编辑 ======
    handleEditFromDetail() {
      this.detailDialog.visible = false
      this.$nextTick(() => {
        this.$message.info(`编辑房源: ${this.detailData.房屋地址}`)
      })
    },
    
    // ====== 修改 ======
    handleEdit() {
       if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }
      this.updateDialogVisible = true
    
    },
    
    // ====== 删除 ======
    handleDelete() {
      if (this.selectedRows.length !== 1) {
          this.$message.warning('请选择一条记录')
          return
        }
        
        const row = this.selectedRows[0]
        
        this.$confirm('是否确认删除？删除后不可撤回！', '提示', {
          type: 'warning',
          confirmButtonText: '确认删除',
          cancelButtonText: '取消'
        }).then(() => {
          this.deletingIds.push(row.id)
          
          const params = {
            tableName: '房源',
            id: row.id
          }
          
          console.log('删除参数===', params)
          
          sqlBaseApi.delete(params).then((res) => {
            console.log('删除返回===', res)
            
            if (res.code === 200) {
              if (res.data?.deleted) {
                this.$message.success('删除成功！')
              } else {
                this.$message.warning(res.data?.message || '记录不存在或已被删除')
              }
              // 刷新列表
              this.loadData()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          }).catch((err) => {
            console.error('删除请求失败===', err)
            this.$message.error(err.message || '删除失败，请稍后重试')
          }).finally(() => {
            this.deletingIds = this.deletingIds.filter(id => id !== row.id)
          })
        }).catch(() => {
          // 用户取消删除
          this.$message.info('已取消删除')
        })
    },
    
// ====== 合同中止 ======
handleContractTerminate() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = JSON.parse(JSON.stringify(this.selectedRows[0]))

  if (!row.合同起始日 || !row.合同到期日) {
    this.$message.warning('该房源缺少合同起始日或合同到期日，无法执行合同中止')
    return
  }

  this.$confirm(
    '合同中止后，剩余的待付计划（含部分付款），均会变成已中止。',
    '合同中止确认',
    {
      type: 'warning',
      confirmButtonText: '确认中止',
      cancelButtonText: '取消'
    }
  ).then(() => {
    const params = {
      房源ID: String(row.id),
      合同起始日: row.合同起始日,
      合同到期日: row.合同到期日
    }

    console.log('合同中止参数===', params)

    sfPlanApi.terminate(params).then((res) => {
      console.log('合同中止返回===', res)

      if (res.code === 200) {
        const affectedCount = res.data?.affectedCount || 0
        this.$message.success(`合同中止成功，共中止 ${affectedCount} 条付款计划`)
        this.loadData()
        if (this.detailDialog.visible && this.detailData.id) {
          this.loadPaymentData(this.detailData.id)
        }
      } else {
        this.$message.error(res.message || '合同中止失败')
      }
    }).catch((err) => {
      console.error('合同中止请求失败===', err)
      this.$message.error(err.message || '合同中止失败，请稍后重试')
    })
  }).catch(() => {
    this.$message.info('已取消合同中止')
  })
},
    
    // ====== 修改附件 ======
    handleAttachment() {
      if (this.selectedRows.length !== 1) return
      this.$message.info(`修改附件: ${this.selectedRows[0].房屋地址}`)
    },
    
    // ====== 更改为待出租 ======
handleChangeToRent() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }

  const row = this.selectedRows[0]

  // 检查当前状态是否已经是待出租
  if (row.业务状态 === '待出租') {
    this.$message.warning('该房源已经是待出租状态')
    return
  }

  this.$confirm(
    `确认将房源 "${row.房屋地址}" 更改为待出租状态吗？`,
    '更改为待出租确认',
    {
      type: 'warning',
      confirmButtonText: '确认更改',
      cancelButtonText: '取消'
    }
  ).then(() => {
    const params = {
      tableName: '房源',
      data: {
        业务状态: '待出租'
      },
      where: {
        id: row.id
      }
    }

    console.log('更改为待出租参数===', params)

    sqlBaseApi.update(params).then((res) => {
      console.log('更改为待出租返回===', res)

      if (res.code === 200) {
        this.$message.success('已成功更改为待出租')
        // 刷新列表
        this.loadData()
        // 如果详情弹窗打开，更新详情数据
        if (this.detailDialog.visible && this.detailData.id === row.id) {
          this.detailData.业务状态 = '待出租'
        }
      } else {
        this.$message.error(res.message || '更改失败')
      }
    }).catch((err) => {
      console.error('更改为待出租请求失败===', err)
      this.$message.error(err.message || '更改失败，请稍后重试')
    })
  }).catch(() => {
    this.$message.info('已取消更改')
  })
},
    
    // ====== 时间戳格式化 ======
    // ====== 时间戳格式化（兼容秒级和毫秒级） ======
formatTimestamp(timestamp) {
  if (!timestamp) return '-'
  let ts = timestamp
  const str = String(ts)
  // 如果是10位数（秒级），转为毫秒级
  if (str.length === 10) {
    ts = ts * 1000
  }
  // 如果是13位数（毫秒级），直接使用
  const date = new Date(ts)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
},
    
    // ====== 刷新数据 ======
    refresh() {
      this.loadData()
    },
     // ====== 楼层信息解析 ======
  getFloorNumber(floorInfo) {
    if (!floorInfo) return '-'
    // 假设格式为 "5/18" 或 "5-18"
    const parts = floorInfo.split(/[\/\-]/)
    return parts[0] || '-'
  },
  
  getTotalFloor(floorInfo) {
    if (!floorInfo) return '-'
    const parts = floorInfo.split(/[\/\-]/)
    return parts[1] || '-'
  },
  
  // ====== 付款状态映射 ======
  getPaymentStatusType(status) {
    const map = {
      'pending': 'danger',      // 红色
      'paid': 'success',        // 绿色
      'partial': 'warning',     // 橙色
      'terminated': 'info',     // 灰色（已中止用黑色，但info是灰色，更接近）
      'other': 'info'           // 灰色
    }
    return map[status] || 'info'
  },
  
  getPaymentStatusLabel(status) {
    const map = {
      'pending': '待付',
      'paid': '已付',
      'partial': '部分付款',
      'terminated': '已中止',
      'other': '其他'
    }
    return map[status] || status
  },
  
  // ====== 日期格式化（用于付款日期） ======
  formatDate(dateStr) {
    if (!dateStr) return '-'
    // 如果已经是 yyyy-MM-dd 格式，直接返回
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr
    }
    // 如果是时间戳，转换
    if (typeof dateStr === 'number') {
      const date = new Date(dateStr * 1000)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    }
    return dateStr
  },
    handleRowDblclick(row) {
  this.detailData = { ...row }
  this.detailActiveTab = 'base'
  this.detailDialog.visible = true
  // 加载附件数据
  if (row.id) {
    this.loadAttachmentData(row.id)
    // 加载付款计划数据
    this.loadPaymentData(row.id)
  }
},
   openAttachmentManager(row) {
     if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }
  // 先设置 fatherId，再打开弹窗
  this.fileFatherId = this.selectedRows[0].id
  this.fileDialogVisible = true
    },
    // ====== 判断是否为图片 ======
isImage(suffix) {
  if (!suffix) return false
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
  return imageTypes.includes(suffix.toLowerCase())
},

// ====== 加载附件数据 ======
// ====== 加载附件数据 ======
async loadAttachmentData(fatherId) {
  if (!fatherId) return
  
  this.attachmentLoading = true
  const type1List = ['产证信息', '身份证信息', '房屋原貌', '房屋托管合同信息', '委托授权书']
  // 修正：使用 /nngy 作为基础路径，拼接时保留 /view
  const fileBaseUrl = window.location.origin + '/nngy'
  
  try {
    const promises = type1List.map(type1 => {
      return fileMethod.listFiles('房源', String(fatherId), type1, null)
        .then(res => {
          if (res.code === 200) {
            let data = res.data?.list || []
            data = data.map(item => {
              if (item.show_path) {
                const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
                // 修正：show_path 本身已包含 /view/xxx，直接用 baseUrl 拼接
                // 注意：show_path 格式为 /view/20260813/xxx.jpg
                item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + item.show_path
              } else {
                item.show_path_full = ''
              }
              return item
            })
            return { type1, data }
          }
          return { type1, data: [] }
        })
        .catch(() => ({ type1, data: [] }))
    })
    
    const results = await Promise.all(promises)
    results.forEach(({ type1, data }) => {
      this.attachmentData[type1] = data
    })
  } catch (error) {
    console.error('加载附件失败:', error)
  } finally {
    this.attachmentLoading = false
  }
},

// ====== 查看文件 ======
handleFileView(row) {
  if (row.show_path_full || row.show_path) {
    const url = row.show_path_full || row.show_path
    window.open(url, '_blank')
  } else {
    this.$message.warning('文件路径不存在')
  }
},

// ====== 下载文件 ======
async handleFileDownload(row) {
  if (!row.show_path) {
    this.$message.warning('文件路径不存在')
    return
  }
  
  const loading = this.$loading({
    lock: true,
    text: '正在下载文件...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  
  try {
    const res = await fileMethod.downloadFile(row.show_path)
    const blob = new Blob([res.data])
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = row.show_name || '下载文件'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
    this.$message.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    this.$message.error('下载失败，请重试')
  } finally {
    loading.close()
  }
  },
  // ====== 打开付款计划弹窗 ======
openPlanDialog() {
  if (this.selectedRows.length !== 1) {
    this.$message.warning('请选择一条记录')
    return
  }
  // 传入深拷贝的数据，避免子组件修改影响原始数据
  this.planRowData = JSON.parse(JSON.stringify(this.selectedRows[0]))
  this.planDialogVisible = true
},
// ====== 加载付款计划数据 ======
async loadPaymentData(fatherId) {
  if (!fatherId) return
  
  this.paymentLoading = true
  
  try {
    const params = {
      房源ID: String(fatherId)
    }
    
    console.log('加载付款计划参数===', params)
    
    const res = await sfPlanApi.select(params)
    console.log('加载付款计划返回===', res)
    
    if (res.code === 200) {
      const list = res.data?.list || []
      // 映射字段，适配表格显示
      this.paymentList = list.map(item => ({
        payment_date: this.formatTimestamp(item.付款日期),
        payment_amount: item.付款金额 || 0,
        status: this.mapPaymentStatus(item.状态),
        remark: item.备注 || '',
        // 保留原始数据以备后续使用
        _raw: item
      }))
      
      console.log('付款计划数据已加载，共', this.paymentList.length, '条')
    } else {
      // 如果没有数据，清空列表
      this.paymentList = []
      console.log('暂无付款计划数据')
    }
  } catch (error) {
    console.error('加载付款计划失败:', error)
    this.paymentList = []
  } finally {
    this.paymentLoading = false
  }
},

// ====== 付款状态映射（后端状态 -> 前端状态） ======
mapPaymentStatus(status) {
  const map = {
    '待付': 'pending',
    '部分付款': 'partial',
    '已完成': 'paid',
    '已中止': 'terminated',
    '已作废': 'other',
    '其他': 'other'
  }
  return map[status] || 'other'
},

}
}
</script>

<style scoped>
.sf-house-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;
}

.filter-section {
  background: #fff;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.filter-form {
  margin-bottom: 0;
}

.button-section {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.button-section .el-button {
  margin-bottom: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
}

.detail-dialog .el-tabs {
  margin-top: 0;
}

.detail-dialog .el-tabs__content {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.attachment-section {
  padding: 10px 0;
}

.attachment-item {
  text-align: center;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;
}

.attachment-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.attachment-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}

.attachment-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.attachment-placeholder {
  width: 100%;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
  border-radius: 4px;
  color: #909399;
}

.attachment-placeholder i {
  font-size: 40px;
  margin-bottom: 8px;
}

@media (max-width: 768px) {
  .sf-house-container {
    padding: 10px;
  }
  
  .filter-form .el-form-item {
    display: block;
    margin-right: 0;
  }
  
  .button-section .el-button {
    margin-bottom: 8px;
  }
}
/* ====== 付款要素和计划 ====== */
.payment-section {
  padding: 10px 0;
}

.empty-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  color: #909399;
}

.empty-payment i {
  font-size: 48px;
  margin-bottom: 12px;
  color: #c0c4cc;
}

.empty-payment span {
  font-size: 14px;
}

/* 修改2：状态标签统一宽度 */
.status-tag {
  display: inline-block;
  width: 80px;
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
}
/* ====== 附件信息 ====== */
.file-group {
  margin-bottom: 24px;
}

.file-group:last-child {
  margin-bottom: 0;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  padding: 8px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}
</style>